import React, { memo, useEffect } from "react";

import ReadAloud from "components/Question/Mocks/Speaking/ReadAloud";
import RepeatSentece from "components/Question/Mocks/Speaking/RepeatSentece";
import DescribeImage from "components/Question/Mocks/Speaking/DescribeImage";
import RetellLec from "components/Question/Mocks/Speaking/RetellLec";
import ShortQue from "components/Question/Mocks/Speaking/ShortQue";
import RespondToSituation from "components/Question/Mocks/Speaking/RespondToSituation";
import SummarizeGroupDiscussion from "components/Question/Mocks/Speaking/SummarizeGroupDiscussion";

import SummarizeWrittenText from "components/Question/Mocks/Writting/Summary";
import WriteEssay from "components/Question/Mocks/Writting/Essay";

import ReadingMCQSingleAnswer from "components/Question/Mocks/Reading/SingleAnswer";
import ReadingMCQMultipleAnswer from "components/Question/Mocks/Reading/MultipleAnswer";
import Reorder from "components/Question/Mocks/Reading/Reorder1";
import ReadingBlank from "components/Question/Mocks/Reading/ReadingBlank";
import ReadingAndWritingBlank from "components/Question/Mocks/Reading/WrittingBlank";

import SummerizeSpoken from "components/Question/Mocks/Listening/Summer";
import ListeningMcqSingle from "components/Question/Mocks/Listening/McqSingle";
import ListeningMcqMulti from "components/Question/Mocks/Listening/McqMulti";
import ListeningFillInTheBlank from "components/Question/Mocks/Listening/ListeningBlank";
import CorrectSummary from "components/Question/Mocks/Listening/CorrectSummary";
import MissingWord from "components/Question/Mocks/Listening/MissingWord";
import Highlight from "components/Question/Mocks/Listening/Highlight";
import Dictation from "components/Question/Mocks/Listening/Dictation";

const CurrentQuestion = memo(function ({
	subcategoryId, props_data
}) {
    // console.log(subcategoryId,props_data);
	const selectedQuestion = () => {
		let question = "";
		
		switch (subcategoryId) {
			case 1:
				question = <ReadAloud {...props_data} />;
				break;
			case 2:
				question = <RepeatSentece {...props_data} />;
				break;
			case 3:
				question = <DescribeImage {...props_data} />;
				break;
			case 4:
				question = <RetellLec {...props_data} />;
				break;
			case 5:
				question = <ShortQue {...props_data} />;
				break;
			// case 21:
			// 	question = <RespondToSituation {...props_data} />;
			// 	break;
			// case 22:
			// 	question = <SummarizeGroupDiscussion {...props_data} />;
			// 	break;
			case 6:
				question = <SummarizeWrittenText {...props_data} />;
				break;
			case 7:
				question = <WriteEssay {...props_data} />;
				break;
			case 8:
				question = <ReadingMCQSingleAnswer {...props_data} />;
				break;
			case 9:
				question = <ReadingMCQMultipleAnswer {...props_data} />;
				break;
			case 10:
				question = <Reorder {...props_data} />;
				break;
			case 11:
				question = <ReadingBlank {...props_data} />;
				break;
			case 12:
				question = <ReadingAndWritingBlank {...props_data} />;
				break;
			case 13:
				question = <SummerizeSpoken {...props_data} />;
				break;
			case 14:
				question = <ListeningMcqSingle {...props_data} />;
				break;
			case 15:
				question = <ListeningMcqMulti {...props_data} />;
				break;
			case 16:
				question = <ListeningFillInTheBlank {...props_data} />;
				break;
			case 17:
				question = <CorrectSummary {...props_data} />;
				break;
			case 18:
				question = <MissingWord {...props_data} />;
				break;
			case 19:
				question = <Highlight {...props_data} />;
				break;
			case 20:
				question = <Dictation {...props_data} />;
				break;
			default:
				// do nothing.
		}

		return question;
	};

	return selectedQuestion();
});

export default CurrentQuestion;